<template>
  <!-- 管理端操作日志-->
  <el-container class="management-operation-log pagination-list">
    <el-main>
      <div class="content">
        <div class="log-search">
          <el-form @submit.native.prevent :inline="true">
            <el-form-item label="开始时间">
              <el-date-picker v-model="params.startTime" placeholder="请选择时间" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker v-model="params.endTime" placeholder="请选择时间" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="操作类型">
              <el-select v-model="params.operationType" clearable placeholder="请选择">
                <el-option label="人员变更" value="人员变更"></el-option>
                <el-option label="权限变更" value="权限变更"></el-option>
                <el-option label="组织变更" value="组织变更"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作者">
              <el-input v-model="params.operator" clearable placeholder="请输入" @keydown.native.enter="search(true)"></el-input>
            </el-form-item>
            <el-button @click="search(true)" style="margin-top: 1px" size="mini">查询</el-button>
          </el-form>
        </div>
        <div class="log-table">
          <el-table
            class="table-list"
            v-loading="loading"
            height="100%"
            :data="data"
            highlight-current-row>
            <el-table-column
              show-overflow-tooltip
              v-for="column in columns"
              :label="column.label"
              :key="column.prop"
              :prop="column.prop"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作列"
              align="center">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">明细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-footer">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="total, prev, pager, next, sizes"
            :currentPage="pagination.currentPage"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            background
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
        class="management-operation-log-dialog"
        title="明细"
        :visible.sync="dialogVisible"
        :width="dialogWidth"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-input
          v-if="!dialogData.jurisdictionChange"
          type="textarea"
          :disabled="true"
          rows="10"
          v-model="dialogData.textarea">
        </el-input>
        <div v-else>
          <el-input
            placeholder="请输入操作对象/操作内容"
            prefix-icon="el-icon-search"
            @input="getPermissionsList(dialogData.selectId)"
            v-model="dialogData.keyWord">
          </el-input>
          <el-table
            class="log-table-dialog"
            :data="dialogData.tableData"
            max-height="300px"
            style="width: 100%">
            <el-table-column
              show-overflow-tooltip
              v-for="column in dialogData.columns"
              :label="column.label"
              :key="column.prop"
              :prop="column.prop"
              align="center">
            </el-table-column>
            <template slot="empty">
              <span>未找到匹配项</span>
            </template>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false;dialogData.tableData = [];dialogData.textarea = '';dialogData.jurisdictionChange = false;dialogData.keyWord = '';dialogData.selectId = ''">关闭</el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'managementOperationLog',
  data () {
    return {
      params: {
        startTime: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        operationType: '',
        operator: ''
      },
      columns: [
        {
          prop: 'operationType',
          label: '操作类型'
        }, {
          prop: 'operationBehavior',
          label: '操作行为'
        }, {
          prop: 'operator',
          label: '操作者'
        }, {
          prop: 'operationTime',
          label: '操作时间'
        }
      ],
      data: [],
      loading: false,
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      dialogVisible: false,
      dialogWidth: '30%',
      dialogData: {
        textarea: '',
        jurisdictionChange: false,
        keyWord: '',
        columns: [
          {prop: 'name', label: '操作对象'},
          {prop: 'type', label: '操作内容'}
        ],
        tableData: [],
        selectId: ''
      }
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    search (isManual) {
      if (!this.params.startTime || !this.params.endTime) {
        return this.$message.error('请选择开始时间与结束时间')
      }
      if (isManual) {
        // 手动点查询时返回第一页
        this.pagination.currentPage = 1
      }
      this.loading = true
      this.$axios.get('/auth-api/operationRecord', {
        params: {
          index: this.pagination.currentPage,
          size: this.pagination.pageSize,
          filters: this.$_.defaults({}, this.params)
        }
      }).then(res => {
        this.data = res.data.items
        this.pagination.total = res.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.search()
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.search()
    },
    // 人员变更、组织变更 的明细展示大文本形式
    // 权限变更：列表形式
    detailClick (row) {
      this.dialogData.selectId = row.id
      if (row.detailType === 'LIST') {
        this.dialogData.jurisdictionChange = true
        this.dialogWidth = '40%'
        this.getPermissionsList(row.id)
      } else {
        this.dialogData.jurisdictionChange = false
        this.dialogWidth = '30%'
        this.$axios.get(`/auth-api/operationRecord/${row.id}`).then(res => {
          this.dialogData.textarea = res.data
        })
      }
      this.dialogVisible = true
    },
    getPermissionsList (id) {
      this.$axios.get(`/auth-api/operationRecord/detail/${id}?filter=${this.dialogData.keyWord}`).then(res => {
        this.dialogData.tableData = res.data.items
      })
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';

  .el-container.management-operation-log {
    font-size: 12px;
    .log-search{
      .el-form {
        height: 37px;
        .el-form-item{
          display: inline-block;
          .el-select .el-select__tags{
            display: flex;
            flex-wrap: nowrap;
            span:nth-child(1){
              max-width: 108px;
              overflow: hidden;
              .el-select__tags-text {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
          .el-input{
            width: 140px;
          }
        }
      }
      .el-button{
        margin-left: 20px;
        border: 1px solid var(--primary, #55ACF1);
        color: var(--primary, #55ACF1);
        padding: 5px;
        vertical-align: middle;
      }
    }
    .log-table{
      height: 100%;
      padding: 0;
      .el-table.table-list{
        border-left: 0;
      }
    }
    .el-main .content .el-input .el-input__inner{
      height: 26px;
      line-height: 26px;
    }
    .management-operation-log-dialog {
      .el-dialog__header span {
        color: #2C2C2C;
      }
      .el-dialog__body {
        textarea {
          resize: none;
          height: 130px;
          color: #2C2C2C;
          background-color: #fff;
        }
        .log-table-dialog {
          margin-top: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/management-operation-log.vue